import Profile from '@/models/Profile';

const GET_EVALUATIONS = 'get_evaluations';
const GET_EVALUATIONS_REQUEST = 'get_evaluations_request';
const GET_EVALUATIONS_SUCCESS = 'get_evaluations_success';
const GET_EVALUATIONS_ERROR = 'get_evaluations_error';

export { GET_EVALUATIONS };

export default {
    state: {
        id: null,
        filter: 'all',
        evaluations: [],
        loading: false,
        evaluationsErrors: [],
        evaluationsMeta: {},
    },
    mutations: {
        [GET_EVALUATIONS_REQUEST]: (state) => {
            state.evaluations = [];
            state.loading = true;
            state.evaluationsErrors = [];
        },
        [GET_EVALUATIONS_SUCCESS]: (state, { evaluations, meta }) => {
            state.evaluations = evaluations;
            state.loading = false;
            state.evaluationsErrors = [];
            state.evaluationsMeta = meta;
        },
        [GET_EVALUATIONS_ERROR]: (state, { errors }) => {
            state.evaluations = [];
            state.loading = false;
            state.evaluationsErrors = errors;
            state.evaluationsMeta = {};
        },
    },
    actions: {
        [GET_EVALUATIONS]: ({ commit, state }, { id = state.id, page = state.evaluationsMeta.current_page, filter = state.filter }) => {
            commit(GET_EVALUATIONS_REQUEST);
            return new Promise((resolve, reject) => {
                Profile.evaluations(id, page, filter)
                    .then(({data, meta}) => {
                        const evaluations = data;
                        commit(GET_EVALUATIONS_SUCCESS, { evaluations, meta });
                        resolve(data);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_EVALUATIONS_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/evaluations.js